
import { isIncludedInPackage } from "@/constants/subscription";
import { defineComponent, ref } from "vue-demi";

export default defineComponent({
  name: "CoSAllocation",

  components: {
    Popup: () => import("@/modules/Pricing/Popup/Popup.vue"),
    FormsTemplate: () => import("@/modules/Pricing/Services/Forms/FormsTemplate.vue"),
  },

  emits: ["ok", "cancel", "close"],

  setup(_, { emit }) {
    const isPopoverOpen = ref(true);

    const onOk = () => {
      emit("ok");
    };

    const onCancel = () => {
      isPopoverOpen.value = false;

      emit("cancel");
    };

    const onClose = () => {
      isPopoverOpen.value = false;

      emit("close");
    };

    return {
      isPopoverOpen,
      onOk,
      onCancel,
      onClose,
      isIncludedInPackage,
    };
  },
});
